var t={};function s(n="pui_id_"){return Object.hasOwn(t,n)||(t[n]=0),t[n]++,`${n}${t[n]}`}export{s as uuid};
//# sourceMappingURL=index.mjs.map